import React from "react";
import { IoAdd } from "react-icons/io5";
import ReceiptList from "./ReceiptList";
import ReceiptForm from "./ReceiptForm";
import { NavLink, useParams } from "react-router-dom";
import { hasPermission } from "../../../../../utils/permission";
import { AccessDenied } from "../../../../../shared-ui/States";

const PlusIcon = () => <IoAdd className="icon" aria-hidden="true" />;

function Receipt() {
  const listPermission = hasPermission("ar-receipt", "view");
  
  return (
    <div className="projects-page">
      <header className="page-header-projects">
        <div className="header-text-content">
          <h1>Receipts</h1>
          <p>View and manage all customer receipts.</p>
        </div>
        <NavLink to="/ar/receipts/new">
          <button className="create-project-button-header">
            <PlusIcon /> Create New Receipt
          </button>
        </NavLink>
      </header>
      {listPermission ? (
        <ReceiptList />
      ) : (
        <AccessDenied description="You do not have permission to view this." />
      )}
    </div>
  );
}

export const ReceiptFormPage = () => {
  let { id } = useParams();
  const createPermission = hasPermission("ar-receipt", "create");
  const updatePermission = hasPermission("ar-receipt", "set");
  
  if (id === "new") {
    if (!createPermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
    id = null;
  } else {
    if (!updatePermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
  }
  
  return (
    <div className="projects-page">
      <NavLink to="/ar/receipts">
        <button className="backbutton">Back To Receipts</button>
      </NavLink>
      <ReceiptForm rowId={id} />
    </div>
  );
};

export default Receipt;
